import React from 'react';
import {
  useParams,
} from 'react-router-dom';
import AdForm from '../components/ad-form';
import Layout from '../components/layout';
import LinkButton from '../components/link-button';
import PageHeader from '../components/page-header';
import './page.css';

const AdPage = () => {
  const { id } = useParams();

  return (
    <Layout>
      <div className="page">
        <PageHeader
          title={`${id ? 'Modifier' : 'Créer'} une publicité`}
        />

        <div className="page_actions">
          <LinkButton
            className="page_action-button"
            icon="arrow_back"
            label="Retour"
            to="/publicites"
            theme="danger"
          />
        </div>

        <AdForm id={parseInt(id, 10)} />
      </div>
    </Layout>
  );
};

export default AdPage;
